/* eslint-disable quotes */
export var Page;
(function (Page) {
    Page["HOME"] = "WELCOME";
    Page["EXPERIENCE"] = "EXPERIENCE";
    Page["YOUTUBE"] = "RESUME";
    Page["WHOAMI"] = "ABOUT ME";
    Page["PROJECTS"] = "PROJECTS";
})(Page || (Page = {}));
